var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Box } from '@ally/metronome-ui';
var InputWrapper = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var media = _a.theme.media;
    return "\n    max-width: 235px;\n\n    ".concat(media.down('md'), " {\n      width: 100%;\n      max-width: none;\n    }\n  ");
});
export default InputWrapper;
var templateObject_1;
//# sourceMappingURL=InputWrapper.js.map